export const SELECTOR = {
  APP: '#app',

  CHARGE_INPUT_FORM: '#charge-input-form',
  CHARGE_INPUT: '#charge-input',

  ALIGN_CONVERTER: '#align-converter',
  PURCHASED_MESSAGE: '#purchased-message',
  LOTTO_CONTAINER: '#lotto-container',

  WIN_NUMBER_INPUT_SECTION: '#win-number-input-section',
  WIN_NUMBER_INPUT_FORM: '#win-number-input-form',

  WINNING_NUMBER_INPUT: '.winning-number-input',
  BONUS_NUMBER_INPUT: '.bonus-number-input',

  WIN_STATISTICS: '#win-statistics',
  STATISTICS_TABLE_BODY: '#statistics-table-body',
  PROFIT_RATIO_TEXT: '#profit-ratio-text',
  RESTART_BUTTON: '#restart-button',
  MODAL_CANCEL_BUTTON: '.modal-cancel-button',
  ALIGN_CONVERTER_CONTAINER: '#align-converter-container',

  HIDE: 'hide',
  SHOW: 'show',
};
